// components/FilterOption.tsx
"use client";
import { Flex, Text } from "@chakra-ui/react";

const FilterOption = ({
  text,
  selected,
  onClick,
  bgColor,
}: {
  text: string;
  selected: boolean;
  bgColor: string;
  onClick: (e: any) => void;
}) => {
  return (
    <Flex
      bg={selected ? "linear-gradient(to right, #FFB5FF, #1AA5D3)" : "transparent"}
      _hover={{ border: `1px solid ${bgColor}`, cursor: "pointer" }}
      border={selected ? `1px solid ${bgColor}` : "1px solid gray"}
      borderRadius="32px"
      justify="center"
      align="center"
      boxShadow="0px 1px 1px 0px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(103, 110, 118, 0.16)"
      minW="40px"
      px={3}
      py={1}
      onClick={onClick}
    >
      <Text
        color={selected ? "black" : "white"}
        fontWeight={600}
        fontSize={{ base: "14px", xl: "14px", "2xl": "14px" }}
        userSelect={"none"}
        flexWrap="wrap"
      >
        {text}
      </Text>
    </Flex>
  );
};

export default FilterOption;
